import _slicedToArray from "/home/hyuto/Hyuto.github.io/v3-beta/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
import { SparseFillEmptyRows } from '@tensorflow/tfjs-core';
import { sparseFillEmptyRowsImplCPU } from '../kernel_utils/shared';
export function sparseFillEmptyRows(args) {
  var inputs = args.inputs,
      backend = args.backend;
  var indices = inputs.indices,
      values = inputs.values,
      denseShape = inputs.denseShape,
      defaultValue = inputs.defaultValue;

  if (denseShape.shape.length !== 1) {
    throw new Error("Dense shape must be a vector, saw:\n         ".concat(denseShape.shape));
  }

  if (indices.shape.length !== 2) {
    throw new Error("Indices must be a matrix, saw:\n         ".concat(indices.shape));
  }

  if (values.shape.length !== 1) {
    throw new Error("Values must be a vector, saw:\n         ".concat(values.shape));
  }

  if (defaultValue.shape.length !== 0) {
    throw new Error("Default value must be a scalar, saw:\n        ".concat(defaultValue.shape));
  }

  var $indices = backend.readSync(indices.dataId);
  var $values = backend.readSync(values.dataId);
  var $denseShape = backend.readSync(denseShape.dataId);
  var $defaultValue = backend.readSync(defaultValue.dataId)[0];

  var _sparseFillEmptyRowsI = sparseFillEmptyRowsImplCPU($indices, indices.shape, indices.dtype, $values, values.dtype, $denseShape, $defaultValue),
      _sparseFillEmptyRowsI2 = _slicedToArray(_sparseFillEmptyRowsI, 5),
      outputIndices = _sparseFillEmptyRowsI2[0],
      outputIndicesShape = _sparseFillEmptyRowsI2[1],
      outputValues = _sparseFillEmptyRowsI2[2],
      emptyRowIndicator = _sparseFillEmptyRowsI2[3],
      reverseIndexMap = _sparseFillEmptyRowsI2[4];

  return [backend.makeTensorInfo(outputIndicesShape, indices.dtype, outputIndices), backend.makeTensorInfo([outputIndicesShape[0]], values.dtype, outputValues), backend.makeTensorInfo([emptyRowIndicator.length], 'bool', new Uint8Array(emptyRowIndicator.map(function (value) {
    return Number(value);
  }))), backend.makeTensorInfo([reverseIndexMap.length], indices.dtype, new Int32Array(reverseIndexMap))];
}
export var sparseFillEmptyRowsConfig = {
  kernelName: SparseFillEmptyRows,
  backendName: 'webgl',
  kernelFunc: sparseFillEmptyRows
};